module.exports = __webpack_public_path__ + "static/media/colicoli27.8dbe71fa.webp";